import api from "../utils/api";

export const addQuestion = async (question, retrieval, attachments, chatMetadata = null, messageMetadata = null, filesMetadata = null, fileSpecificMetadata = null) => {
  const endpoint = `cognitive/assistants/${retrieval}/chats/`;

  const formData = new FormData();
  formData.append("message", question);

  // Add chat metadata if provided (only for new chats)
  if (chatMetadata && Object.keys(chatMetadata).length > 0) {
    formData.append("chat_metadata", JSON.stringify(chatMetadata));
  }

  // Add message metadata if provided
  if (messageMetadata && Object.keys(messageMetadata).length > 0) {
    formData.append("metadata", JSON.stringify(messageMetadata));
  }

  // Helper function to convert metadata cards to object
  const convertCardsToObject = (cards) => {
    const obj = {};
    if (cards && cards.length > 0) {
      cards.forEach(card => {
        if (card.key && card.values) {
          obj[card.key] = card.values.length === 1 ? card.values[0] : card.values;
        }
      });
    }
    return obj;
  };

  // Convert global metadata cards to object
  const globalMetadataObject = convertCardsToObject(filesMetadata);

  if (attachments != null) {
    if (Array.isArray(attachments)) {
      // Append as file_1, file_2, file_3, etc.
      attachments.forEach((file, index) => {
        formData.append(`file_${index + 1}`, file);
        
        // Start with global metadata
        const fileMetadataObject = { ...globalMetadataObject };
        
        // Check for file-specific metadata (by file name)
        if (fileSpecificMetadata && fileSpecificMetadata[file.name]) {
          const specificCards = fileSpecificMetadata[file.name];
          const specificObj = convertCardsToObject(specificCards);
          // Specific metadata overrides global
          Object.assign(fileMetadataObject, specificObj);
        }
        
        // Only send if there's metadata
        if (Object.keys(fileMetadataObject).length > 0) {
          formData.append(`metadata_${index + 1}`, JSON.stringify(fileMetadataObject));
        }
      });
    } else {
      formData.append("file_1", attachments);
      
      // Start with global metadata
      const fileMetadataObject = { ...globalMetadataObject };
      
      // Check for file-specific metadata
      if (fileSpecificMetadata && fileSpecificMetadata[attachments.name]) {
        const specificCards = fileSpecificMetadata[attachments.name];
        const specificObj = convertCardsToObject(specificCards);
        Object.assign(fileMetadataObject, specificObj);
      }
      
      if (Object.keys(fileMetadataObject).length > 0) {
        formData.append("metadata_1", JSON.stringify(fileMetadataObject));
      }
    }
  }

  const resp = await api.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return resp;
};

export const addQuestionAsync = async (question, retrieval, attachments, chatMetadata = null, messageMetadata = null, filesMetadata = null, fileSpecificMetadata = null) => {
  const endpoint = `cognitive/assistants/${retrieval}/chats/async/`;

  const formData = new FormData();
  formData.append("message", question);

  // Add chat metadata if provided (only for new chats)
  if (chatMetadata && Object.keys(chatMetadata).length > 0) {
    formData.append("chat_metadata", JSON.stringify(chatMetadata));
  }

  // Add message metadata if provided
  if (messageMetadata && Object.keys(messageMetadata).length > 0) {
    formData.append("metadata", JSON.stringify(messageMetadata));
  }

  // Helper function to convert metadata cards to object
  const convertCardsToObject = (cards) => {
    const obj = {};
    if (cards && cards.length > 0) {
      cards.forEach(card => {
        if (card.key && card.values) {
          obj[card.key] = card.values.length === 1 ? card.values[0] : card.values;
        }
      });
    }
    return obj;
  };

  // Convert global metadata cards to object
  const globalMetadataObject = convertCardsToObject(filesMetadata);

  if (attachments != null) {
    if (Array.isArray(attachments)) {
      // Append as file_1, file_2, file_3, etc.
      attachments.forEach((file, index) => {
        formData.append(`file_${index + 1}`, file);

        // Start with global metadata
        const fileMetadataObject = { ...globalMetadataObject };

        // Check for file-specific metadata (by file name)
        if (fileSpecificMetadata && fileSpecificMetadata[file.name]) {
          const specificCards = fileSpecificMetadata[file.name];
          const specificObj = convertCardsToObject(specificCards);
          // Specific metadata overrides global
          Object.assign(fileMetadataObject, specificObj);
        }

        // Only send if there's metadata
        if (Object.keys(fileMetadataObject).length > 0) {
          formData.append(`metadata_${index + 1}`, JSON.stringify(fileMetadataObject));
        }
      });
    } else {
      formData.append("file_1", attachments);

      // Start with global metadata
      const fileMetadataObject = { ...globalMetadataObject };

      // Check for file-specific metadata
      if (fileSpecificMetadata && fileSpecificMetadata[attachments.name]) {
        const specificCards = fileSpecificMetadata[attachments.name];
        const specificObj = convertCardsToObject(specificCards);
        Object.assign(fileMetadataObject, specificObj);
      }

      if (Object.keys(fileMetadataObject).length > 0) {
        formData.append("metadata_1", JSON.stringify(fileMetadataObject));
      }
    }
  }

  const resp = await api.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return resp;
};

export const getChat = async (id) => {
  const { data } = await api.get(`cognitive/chats/${id}/`);
  return data;
};

export const getChats = async (retrieval) => {
  const { data } = await api.get(`cognitive/assistants/${retrieval}/chats/`);
  return data;
};

export const addFeedback = async (chat, like, comment) => {
  const endpoint = `cognitive/chats/${chat}/`;
  if (comment === "") {
    const { data } = await api.put(endpoint, { like: like });
    return data;
  }
  const { data } = await api.put(endpoint, { like: like, comment: comment });
  return data;
};

export const addFeedback2 = async (chat, comment) => {
  const endpoint = `cognitive/chats/${chat}/`;
  const { data } = await api.put(endpoint, { comment: comment });
  return data;
};

export const matrixMode = async (chat, matrixMode) => {
  const endpoint = `cognitive/chats/${chat}/`;
  const resp = await api.put(endpoint, { matrix_mode: matrixMode });
  return resp;
};

export const retryChat = async (chatId, success = undefined) => {
  const endpoint = `cognitive/chats/${chatId}/retry/`;
  const body = success !== undefined ? { success } : undefined;
  const resp = await api.post(endpoint, body);
  return resp;
};

const QuestionsApi = {
  addQuestion,
  addQuestionAsync,
  getChat,
  getChats,
  addFeedback,
  addFeedback2,
  matrixMode,
  retryChat,
};

export default QuestionsApi;
